import './TagNameInput.scss';
import { TagColorPicker } from './TagColorPicker';
import { Form, Input, Popover } from 'antd';
import { PLACEHOLDERS_COPY, TAG_NAME } from '@sonar-software/sonar-ts-constants';
import React, { useState } from 'react';
const requiredRule = {
    message: TAG_NAME.REQUIRED_MESSAGE,
    required: true
};
const lengthRule = {
    max: TAG_NAME.MAX_LENGTH,
    message: TAG_NAME.MAX_MESSAGE,
    type: 'string'
};
const rules = [requiredRule, lengthRule];
export const TagNameInput = ({ disabled, getPopupContainer, hexColor, name, onColorClick, onEnter }) => {
    const [isOpen, setIsOpen] = useState(false);
    const handleOpenChange = (newOpen) => (disabled ?
        setIsOpen(false) :
        setIsOpen(newOpen));
    return (React.createElement(Popover, { className: 'tag-name-input', content: React.createElement(TagColorPicker, { color: hexColor, onChange: onColorClick }), getPopupContainer: getPopupContainer, onOpenChange: handleOpenChange, open: isOpen, placement: 'left' },
        React.createElement(Form.Item, { name: name, rules: rules },
            React.createElement(Input, { disabled: disabled, onPressEnter: onEnter, placeholder: PLACEHOLDERS_COPY.TAG_NAME, prefix: React.createElement("div", { className: 'hex-color-circle', style: { backgroundColor: hexColor } }) }))));
};
